import { render, staticRenderFns } from "./page-footer-win3.vue?vue&type=template&id=160a7338&scoped=true&"
import script from "./page-footer-win3.vue?vue&type=script&lang=js&"
export * from "./page-footer-win3.vue?vue&type=script&lang=js&"
import style0 from "./page-footer-win3.vue?vue&type=style&index=0&id=160a7338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a7338",
  null
  
)

export default component.exports